import { render, staticRenderFns } from "./goodsPane.vue?vue&type=template&id=5b2ff30c"
import script from "./goodsPane.vue?vue&type=script&lang=js"
export * from "./goodsPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports